import { render, staticRenderFns } from "./token-box1.vue?vue&type=template&id=e21391d6&scoped=true&"
import script from "./token-box1.vue?vue&type=script&lang=js&"
export * from "./token-box1.vue?vue&type=script&lang=js&"
import style0 from "./token-box1.vue?vue&type=style&index=0&id=e21391d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21391d6",
  null
  
)

export default component.exports